export default __webpack_public_path__ + "static/media/jpg.1dabc06e.jpg";